export const positions = [
  "Interior Offensive Line",
  "Wide Receiver",
  "Offensive Tackle",
  "Slot Receiver",
  "Quarterback",
  "Running Back",
  "Tight End",
  "Corner",
  "Safety",
  "Edge/Outside Linebacker",
  "Linebacker",
  "Defensive End",
  "Defensive Tackle",
  "Kicker",
  "Punter",
  "Long Snapper",
];

export const states = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

export const sports = [
  "Badminton",
  "Baseball",
  "Bowling",
  "Cheerleading",
  "Competitive Spirit Squads",
  "CrossCountry",
  "DanceTeam",
  "FieldHockey",
  "Football",
  "Golf",
  "Gymnastics",
  "Hockey",
  "Indoor Track & Field",
  "Lacrosse",
  "Skiing & Snowboarding",
  "Soccer",
  "Softball",
  "Surf",
  "Swimming & Diving",
  "Tennis",
  "Track & Field",
  "Volleyball",
  "Water Polo",
  "Weightiifting",
  "Wrestling",
];

export const tshirtSizes = ["XS", "S", "M", "L", "XL", "XXL", "XXXL", "XXXXL"];
